import { Autocomplete, TextField, TextFieldProps } from '@mui/material';
import React from 'react';

export interface UsState {
  value: string;
  label: string;
}
interface Props {
  initialValue?: string;
  onChangeAutoComplete?: (value: string | undefined) => void;
  onBlurAutoComplete?: () => void;
}

const usStatesOptions: UsState[] = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

export default function UsStatesSelector({
  initialValue,
  onChangeAutoComplete,
  onBlurAutoComplete,
  ...textFieldProps
}: Props & TextFieldProps) {
  const [option, setOption] = React.useState<UsState | null>(null);
  const [inputValue, setInputValue] = React.useState('');
  return (
    <Autocomplete
      id="us-states-id"
      options={usStatesOptions}
      value={
        option ||
        (initialValue
          ? usStatesOptions.find((s) => s.value === initialValue)
          : null)
      }
      onChange={(event: any, newValue: UsState | null) => {
        setOption(newValue);
        onChangeAutoComplete?.(newValue?.value);
      }}
      onBlur={() => onBlurAutoComplete?.()}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="State"
          fullWidth
          variant="filled"
          className="no-shadow"
          helperText="Select or begin typing the name of the state"
          {...textFieldProps}
        />
      )}
    />
  );
}
